import React from 'react';
import dateFormat from 'dateformat';

// STYLEDS
import * as S from './SearchWidgetUI.styles';
import * as styles from '../Autosuggests/SearchWidget/SearchWidgetAutosuggest.styles';

// COMPONENTS
import SearchWidgetAutosuggest from '../Autosuggests/SearchWidget/SearchWidgetAutosuggest';
import CalendarBlock from '../../HomePage/CalendarBlock/CalendarBlock';
import PaxWidget from '../../HomePage/PaxWidget/PaxWidget';

// UTILS
import {convertRoomStringToReadable} from '../../../../../shared/utils/room-string-utils';

// HOOKS
import useSearchWidgetUI from '../../../../../shared/hooks/useSearchWidgetUI';

import {FlexItem} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

const SearchWidgetUI = ({
  updateQueryCaller,
  autosuggestHandler,
  roomString,
  checkin,
  checkout,
  searchInputValue,
  updateSearch,
  gaHandler,
}) => {
  const {
    calendarBlockRef,
    paxWidgetBlockRef,
    calendarMode,
    closeCalendar,
    setCalendarMode,
    isPaxWidgetVisible,
    togglePaxWidget,
  } = useSearchWidgetUI();

  const isCalendarVisible = calendarMode !== '';

  return (
    <S.OuterWrapDiv>
      <S.WrapperStyle>
        <FlexItem>
          <S.SearchWrapperArea>
            {(searchInputValue && (
              <SearchWidgetAutosuggest
                initialInputValue={searchInputValue}
                onItemSelection={changes => {
                  autosuggestHandler(changes);
                  gaHandler('location', changes?.selectedItem?.n);
                }}
              />
            )) || (
              <styles.AutocompleteWrapperStyles>
                <styles.SearchLabelStyles>AREA, LANDMARK OR HOTEL NAME</styles.SearchLabelStyles>
                <styles.SearchInputStyles placeholder="LOCATION NAME" />
              </styles.AutocompleteWrapperStyles>
            )}
          </S.SearchWrapperArea>
          <S.CheckinCheckoutWrapper id="search-widget-calendar-element">
            <div
              onClick={() => {
                setCalendarMode('checkin');
                if (isPaxWidgetVisible) togglePaxWidget(false);
              }}
            >
              <S.SearchLabelStyle>CHECKIN</S.SearchLabelStyle>
              <S.SearchInputStyle
                type="text"
                value={
                  (checkin &&
                    // checkout &&
                    `${dateFormat(checkin.date, 'mediumDate')}`) ||
                  ''
                }
                placeholder="Travel Dates"
                id="search-widget-checkin-input"
                editable="false"
              />
            </div>
            {(calendarMode === 'checkin' && (
              <CalendarBlock
                ref={calendarBlockRef}
                isSearchWidget={true}
                isCheckinMode={calendarMode === 'checkin'}
                isCheckoutMode={false}
                onSelection={() => setCalendarMode('checkout')}
                updateQueryCaller={updateQueryCaller}
                checkin={checkin}
                checkout={checkout}
                gaHandler={gaHandler}
              />
            )) ||
              null}
          </S.CheckinCheckoutWrapper>
          <S.CheckinCheckoutWrapper>
            <div
              onClick={() => {
                setCalendarMode('checkout');
                if (isPaxWidgetVisible) togglePaxWidget(false);
              }}
            >
              <S.SearchLabelStyle>CHECKOUT</S.SearchLabelStyle>
              <S.SearchInputStyle
                type="text"
                value={(checkin && checkout && `${dateFormat(checkout.date, 'mediumDate')}`) || ''}
                placeholder="Travel Dates"
                editable="false"
              />
            </div>
            {(calendarMode === 'checkout' && (
              <CalendarBlock
                ref={calendarBlockRef}
                isSearchWidget={true}
                isCheckinMode={false}
                isCheckoutMode={calendarMode === 'checkout'}
                onSelection={() => {
                  closeCalendar();
                  updateSearch();
                }}
                updateQueryCaller={updateQueryCaller}
                checkin={checkin}
                checkout={checkout}
                gaHandler={gaHandler}
              />
            )) ||
              null}
          </S.CheckinCheckoutWrapper>

          <S.PaxWrapperStyle
            onClick={() => {
              if (isCalendarVisible) closeCalendar();

              if (!isPaxWidgetVisible) {
                togglePaxWidget(true);
              }
            }}
          >
            <S.SearchLabelStyle>GUEST & ROOMS</S.SearchLabelStyle>
            <S.SearchInputStyle
              type="text"
              value={convertRoomStringToReadable(roomString)}
              editable="false"
            />
            {(isPaxWidgetVisible && (
              <PaxWidget
                ref={paxWidgetBlockRef}
                togglePaxWidget={togglePaxWidget}
                updateQueryCaller={updateQueryCaller}
                roomString={roomString}
                gaHandler={gaHandler}
                updateSearch={updateSearch}
              />
            )) ||
              ''}
          </S.PaxWrapperStyle>
        </FlexItem>
        <S.UpdateSearchBtn onClick={updateSearch}>UPDATE SEARCH</S.UpdateSearchBtn>
      </S.WrapperStyle>
    </S.OuterWrapDiv>
  );
};

export default SearchWidgetUI;
